<template>
  <section role="article" :class="[baseCss, `text-${align}`, 'outline-none', fullHeight ? 'min-h-full' : null, 'block', overflowOff ? 'overflow-hidden' : null, rounded ? 'rounded' : null, `shadow-${elevation}`, internalTextColor, internalBgColor]" :to="to" :is="tag">
    <slot />
  </section>
</template>
<script>
import methods from '../../mixins/methods'
import computed from '../../mixins/computed'
import props from '../../mixins/props'

export default {
  name: 'Card',
  mixins: [
    props,
    methods,
    computed
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('card', [])
    }
  },
  props: {
    align: {
      type: String,
      default: 'auto',
      validator: value => {
        return ['left', 'center', 'right', 'justify', 'auto'].includes(value)
      }
    },
    rounded: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: 'section'
    },
    to: {
      type: String
    },
    color: {
      type: String,
      default: 'black'
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    fullHeight: {
      type: Boolean
    },
    overflowOff: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/card/card.vue